<template>
  <div class="container" id="drill">
    <div class="counter">
      <span class="count">{{ this.counter }}</span>
      / {{ length }}
    </div>
    <h2>
      {{ quiz[this.counter - 1].ko === 1 ? "子" : "親" }}・{{
        quiz[this.counter - 1].agari === 1 ? "ロン" : "ツモ"
      }}
    </h2>
    <div class="quiz-info" v-if="this.page % 2 == 1">
      {{ quiz[this.counter - 1].fu }}符 {{ quiz[this.counter - 1].yaku }}翻
    </div>
    <div class="quiz-info" v-if="this.page % 2 == 0">
      {{ quiz[this.counter - 1].tensu1 }}
      <span v-if="quiz[this.counter - 1].tensu2 != 0"
        >/ {{ quiz[this.counter - 1].tensu2 }}</span
      >
    </div>
    <span
      v-if="
        this.page % 2 == 0 &&
          quiz[this.counter - 1].ko == 2 &&
          quiz[this.counter - 1].agari == 2
      "
      >オール</span
    >
    <div>
      <a
        class="waves-effect waves-light btn btn-answer pink lighten-2"
        @click="goNext"
        v-if="this.page % 2 == 1"
        >解答</a
      >
      <a
        class="waves-effect waves-light btn btn-next blue darken-1"
        @click="goNext"
        v-if="this.page % 2 == 0 && this.page != this.length * 2"
        >次の問題</a
      >
      <a
        class="waves-effect waves-light btn btn-next pink lighten-2"
        @click="goResult"
        v-if="this.page % 2 == 0 && this.page == this.length * 2"
        >終了</a
      >
    </div>
  </div>
</template>

<script>
import tensu from "../assets/scoreMap.json";

export default {
  name: "drill",
  data() {
    return {
      level: 1,
      length: 10,
      ko: 1,
      agari: 1,
      counter: 1,
      correct: 0,
      quiz: [],
      page: 1,
      timer: 0,
      timerObj: null,
    };
  },
  methods: {
    goNext() {
      // 問題が解き終わったら結果ページへ遷移
      if (this.counter >= this.length * 2) {
        this.$router.push({
          name: "result",
          query: {
            level: this.level,
            length: this.length,
            ko: this.ko,
            agari: this.agari,
            counter: this.counter,
            correct: this.correct,
          },
        });
      } else {
        // 次のページを表示
        this.page += 1;
        // 次のページが問題ページの場合
        if (this.page % 2 == 1) {
          this.counter += 1;
          console.log(this.quiz[this.counter - 1]);
        }
        // 正解だった場合
        // if (this.ko === false) {
        //   this.correct += 1;
        // }
      }
    },
    goResult() {
      clearInterval(this.timerObj);
      this.$router.push({
        name: "result",
        query: {
          level: this.level,
          length: this.length,
          ko: this.ko,
          agari: this.agari,
          counter: this.counter,
          correct: this.correct,
          timer: this.timer,
        },
      });
    },
  },
  created() {
    this.level = this.$route.query.level;
    this.length = this.$route.query.length;
    this.ko = this.$route.query.ko;
    this.agari = this.$route.query.agari;
    this.timer = 0;
    this.timerObj = null;

    // 難易度別
    if (this.level === 1) {
      const callback = (item) =>
        item.fu === 30 || item.fu === 40 || item.fu === 50;
      this.quiz = tensu.filter((item) => callback(item));
    } else if (this.level === 2) {
      const callback = (item) =>
        item.fu === 20 ||
        item.fu === 25 ||
        item.fu === 30 ||
        item.fu === 40 ||
        item.fu === 50;
      this.quiz = tensu.filter((item) => callback(item));
    } else {
      this.quiz = tensu;
    }
    console.log(this.quiz);
    // 親子判別
    if (this.ko === 1) {
      const callback = (item) => item.ko === 1;
      this.quiz = this.quiz.filter((item) => callback(item));
    } else if (this.ko === 2) {
      const callback = (item) => item.ko === 2;
      this.quiz = this.quiz.filter((item) => callback(item));
    }
    // あがり方判別
    if (this.agari === 1) {
      const callback = (item) => item.agari === 1;
      this.quiz = this.quiz.filter((item) => callback(item));
    } else if (this.agari === 2) {
      const callback = (item) => item.agari === 2;
      this.quiz = this.quiz.filter((item) => callback(item));
    }
    // ランダムに並び替え
    const shuffle = ([...array]) => {
      console.log(array.length);
      console.log(array);
      for (let i = array.length - 1; i >= 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
      }
      return array;
    };

    this.quiz = shuffle(this.quiz);
  },
  mounted() {
    //表示後にやりたいことはここに書ける
    this.timer = Number(0);
    this.timerObj = setInterval(() => {
      this.timer += 1;
      // console.log(this.timer);
    }, 100);
  },
  beforeDestroy: function() {
    clearInterval(this.timerObj);
    this.timerObj = null;
  },
};
</script>

<style lang="scss" scoped>
#drill {
  &.container {
    padding-top: 100px;
  }
  h2 {
    text-align: center;
    margin: 12px 0;
    font-size: 24px;
  }
}
.counter {
  text-align: left;
  position: relative;
  top: 0px;
  left: 10px;
  font-size: 20px;
  .count {
    font-size: 24px;
    font-weight: bold;
  }
}
.quiz-info {
  font-size: 28px;
  margin-top: 20px;
}
.btn-next {
  margin-top: 20px;
  color: #fff !important;
}
.btn-answer {
  margin-top: 20px;
  color: #fff !important;
}
</style>
